import React from 'react';
import { trans } from '../../localization';
import { PageTitle } from '../../components/Common/PageTitle';

class Dashboard extends React.Component {
  render() {
    return (
      <React.Fragment>
        <div style={{ textAlign: 'center', padding: '167px 100px 0' }}>
          <PageTitle title={trans('rebranding.merchant_dashboard')} />
          <p style={{
            margin:'17px 0 0'
          }}
          >{trans('rebranding.mod_welcome_to_merchant_description')}
          </p>
        </div>
      </React.Fragment>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./foody/src/pages/Dashboard/Dashboard.jsx